import '../css/App.css';
import '../css/Site.css';
import logo from '../img/logo-light.png';
import { Link, NavLink } from "react-router-dom";
import React, { useState } from "react";

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/works", label: "Portfolio" },
  { to: "/process", label: "Process" },
  { to: "/resume", label: "Resume" },
];

function Comp_Header() {
  const [isOpen, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <header className="pb-header">
      <Link to="/" className="pb-logo-link" onClick={close}>
        <img className="pb-logo" src={logo} alt="Pixelbear Digital Studio" />
      </Link>

      <button
        type="button"
        className={`pb-menu-btn ${isOpen ? 'open' : ''}`}
        onClick={() => setOpen(!isOpen)}
        aria-label={isOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={isOpen}
      >
        <span />
      </button>

      <nav>
        <ul className={`pb-nav ${isOpen ? 'open' : ''}`}>
          {NAV_LINKS.map(({ to, label }) => (
            <li key={to}>
              <NavLink to={to} end onClick={close}>{label}</NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
}

export default Comp_Header;
